module.exports = __webpack_public_path__ + "media/Slide5.09bcd4cf.mp3";